module.exports = require('../each');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/object/for-in.js
// module id = 303
// module chunks = 0 1 2